import { Decimal } from 'decimal.js';
function sumByLine(rows, qtyOf) {
    const byLine = new Map();
    for (const row of rows) {
        const sum = byLine.get(row.salesOrderItemId) ?? new Decimal(0);
        byLine.set(row.salesOrderItemId, sum.plus(qtyOf(row)));
    }
    return byLine;
}
/** True when the capture turns away every unit that went out, which Mark Delivered refuses (DLV spec §7). */
export function isEveryUnitRejected(lines, capture) {
    const shippedByLine = [...sumByLine(lines, (line) => line.shippedQty)].filter(([, shipped]) => shipped.greaterThan(0));
    const rejectedByLine = sumByLine(capture, (row) => row.qtyRejected);
    return (shippedByLine.length > 0 &&
        shippedByLine.every(([lineId, shipped]) => (rejectedByLine.get(lineId) ?? new Decimal(0)).greaterThanOrEqualTo(shipped)));
}
/** Why an all-rejected Mark Delivered is refused, and what to do instead. */
export function everyUnitRejectedMessage(path) {
    return path === 'Standard'
        ? 'Every unit was rejected. Use Failed Delivery instead.'
        : 'Every unit was rejected. Cancel the order instead.';
}
//# sourceMappingURL=is-every-unit-rejected.js.map